
webpack.register(
    'components/image-universal/image-universal',
    function() {
        return require('components/image-universal/image-universal');
    },
    false
);
webpack.register(
    'components/social-share/social-share',
    function() {
        return require('components/social-share/social-share');
    },
    false
);
webpack.register(
    'components/clamp-text/clamp-text',
    function() {
        return require('components/clamp-text/clamp-text');
    },
    false
);
var stache = require('can/view/stache/stache');
module.exports = stache("<can-import from='components/image-universal/image-universal'/>\r\n<can-import from='components/social-share/social-share'/>\r\n<can-import from='components/clamp-text/clamp-text' />\r\n\r\n<div class=\"c-related-article-card c-card c-card__content c-card__content--article\">\r\n    <a href=\"{{getCardLink}}\" data-analytics-track=\"true\"\r\n       {{#if isPinned}}data-analytics-pinned-content=\"{{title}}\"{{/if}}\r\n       data-analytics-content-item-number=\"{{cardIndex}}\"\r\n       data-analytics-content-item-type=\"Article\">\r\n        <div class=\"s-two-side\">\r\n            <div class=\"s-two-side__left\">\r\n                <image-universal class-name=\"s-preview__img\" {image}='image' />\r\n            </div>\r\n            <div class=\"s-two-side__right\">\r\n                <div class=\"s-title\">\r\n                    <clamp-text\r\n                        {text}=\"'{{title}}'\"\r\n                        {lines}=\"3\" />\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </a>\r\n\r\n    <div class=\"s-share\">\r\n        <social-share\r\n                title=\"{{title}}\"\r\n                {page-path}=\"'{{getCardLink}}'\">\r\n        </social-share>\r\n    </div>\r\n</div>\r\n");